import { Routes } from "@angular/router";
import { authenticatedGuardBuilder } from "./core/guards/authenticated/authenticated.guard";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "auth/login"
  },
  {
    path: "anzitutto",
    canActivate: [authenticatedGuardBuilder({ mustBeAuthenticated: true })],
    loadComponent: () =>
      import(
        "./core/components/root-authenticated/root-authenticated.component"
      ).then((m) => m.RootAuthenticatedComponent),
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "users"
      },
      {
        path: "users",
        loadChildren: () =>
          import("./features/users/users.routes").then((m) => m.routes)
      },
      {
        path: "organizations",
        loadChildren: () =>
          import("./features/organizations/organizations.routes").then(
            (m) => m.routes
          )
      },
      {
        path: "centers",
        loadChildren: () =>
          import("./features/centers/centers.routes").then((m) => m.routes)
      },
      {
        path: "events",
        loadChildren: () =>
          import("./features/events/events.routes").then((m) => m.routes)
      },
      {
        path: "contacts",
        loadChildren: () =>
          import("./features/contacts/contacts.routes").then((m) => m.routes)
      },
      {
        path: "**",
        redirectTo: "users"
      }
    ]
  },
  {
    path: "auth",
    canActivate: [authenticatedGuardBuilder({ mustBeAuthenticated: false })],
    loadComponent: () =>
      import(
        "./core/components/root-authentication/root-authentication.component"
      ).then((m) => m.RootAuthenticationComponent),
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./features/auth/auth.routes").then((m) => m.routes)
      },
      {
        path: "**",
        redirectTo: "login"
      }
    ]
  },
  {
    path: "**",
    redirectTo: "auth/login"
  }
];
